import { Box, Button, styled } from '@mui/material';

import { COLORS } from '../../../../../../configs/colors';

export const StatusFlowIndicator = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '12px 16px',
  backgroundColor: COLORS.BackgroundGrey,
  borderBottom: `1px solid ${COLORS.SubtleGrey}`,
});

export const FlowCurrent = styled(Box)({
  fontSize: 13,
  fontWeight: 600,
  color: COLORS.NavyBlue,
  padding: '4px 10px',
  backgroundColor: COLORS.LightBlueBackground,
  borderRadius: 6,
});

export const FlowArrow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  color: COLORS.Gray,
});

export const FlowNext = styled(Box)({
  fontSize: 13,
  color: COLORS.Gray,
  fontStyle: 'italic',
});

export const StatusGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: 12,
  padding: 16,
});

export const StatusOption = styled(Button)`
  padding: 16px;
  text-transform: none;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  border: 1px solid ${COLORS.SubtleGrey};
  color: ${COLORS.NavyBlue};

  &:hover {
    background-color: ${COLORS.LightBlueBackground};
    border-color: ${COLORS.NavyBlue};
  }
`;

export const InteractionSection = styled(Box)({
  padding: 16,
});

export const InteractionTitle = styled(Box)({
  fontSize: 16,
  fontWeight: 600,
  color: COLORS.NavyBlue,
  marginBottom: 12,
});

export const FormField = styled(Box)({
  marginBottom: 16,
});

export const FieldLabel = styled(Box)({
  fontSize: 12,
  color: COLORS.Gray,
  marginBottom: 4,
});

export const RequiredMark = styled('span')({
  color: COLORS.DarkRed,
  marginLeft: 2,
});

export const NoStatusesMessage = styled(Box)({
  padding: '32px 16px',
  textAlign: 'center',
  color: COLORS.Gray,
  fontSize: 14,
});

export const LoadingContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 32,
});

export const ErrorMessage = styled(Box)({
  padding: 16,
  backgroundColor: COLORS.LightRedBackground,
  color: COLORS.DarkRed,
  borderRadius: 8,
  margin: 16,
  fontSize: 14,
});

export const ConfirmContent = styled(Box)({
  flex: 1,
  overflowY: 'auto',
});

export const SelectedStatusBadge = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 16,
  margin: 16,
  backgroundColor: COLORS.LightBlueBackground,
  border: `2px solid ${COLORS.NavyBlue}`,
  borderRadius: 8,
  fontSize: 18,
  fontWeight: 600,
  color: COLORS.NavyBlue,
});
